import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { ProductImage } from '../../../ui/ProductImage';
import { useCatalog } from '../../../contexts/CatalogContext';
import { useCartActions, useOverlayActions } from '../../../contexts/StoreContext';
import { useSignedInAccount } from '../../../contexts/AccountContext';
import { founder } from '../../../data/content';
import { euro } from '../../../core/format/currency';
import { isAllSoldOut, isSoldOut } from '../../../core/rules/stock';
import { lastVisit } from '../../../utils/account';
import { btnPrice, btnPriceAmount, btnPriceLabel } from '../../../ui/styles';
import { accountHeading } from '../../../ui/sections';
const THUMBS = 5;

/**
 * Voor wie (nog) niets thuis gebruikt: het protocol dat bij haar behandeling
 * hoort. Geen verkooppraat, wel de logische volgende stap — en makkelijk te negeren.
 */
export function HomeCareCard() {
  const {
    account
  } = useSignedInAccount();
  const {
    routineForTreatment,
    routineTotals,
    routines,
    treatmentBySlug
  } = useCatalog();
  const {
    addRoutine
  } = useCartActions();
  const {
    openQuiz
  } = useOverlayActions();
  const anchorSlug = account.course?.treatmentSlug ?? lastVisit(account)?.treatmentSlug;
  const treatment = anchorSlug ? treatmentBySlug(anchorSlug) : undefined;
  const routine = anchorSlug && routineForTreatment(anchorSlug) || routines.find(r => r.level === 'Start') || routines[0];
  if (!routine) return null;
  const {
    items,
    price
  } = routineTotals(routine);
  const allSoldOut = isAllSoldOut(items);
  return <section aria-labelledby="homecare-title" className="bg-shell p-5 ring-1 ring-line sm:p-7" data-id="element-6107" data-mp="3zxb11qqc6hg">
      <p className="text-[13px] text-muted" data-id="element-6108" data-mp="3m61wn6ghdx6z">{treatment ? `Bij je ${treatment.name}` : 'Thuis beginnen'}</p>
      <h2 id="homecare-title" className={`mt-1 ${accountHeading}`} data-id="element-6109" data-mp="3r3lcubwqok1k">
        {treatment ? 'Het resultaat thuis vasthouden' : 'Eén routine die klopt'}
      </h2>
      <p className="mt-2 text-[14px] leading-relaxed text-muted" data-id="element-6110" data-mp="2fqj2vzp5asqd">
        {treatment ? `Wat ${founder.firstName} in de salon doet, houd je thuis vast met het ${routine.name}. ${routine.claim}` : `${routine.name}: ${routine.claim}`}
      </p>

      <ul className="mt-4 flex flex-wrap gap-2" aria-label={`In het ${routine.name}`} data-id="element-6111" data-mp="gd11rrrdc82f">
        {items.slice(0, THUMBS).map(p => <li key={p.id} className="h-14 w-14 bg-sand" title={p.name} data-id="element-6112" data-mp="7iw70x946chm">
            <ProductImage src={p.image} alt={p.name} className={`h-full w-full p-1 ${isSoldOut(p) ? 'opacity-50' : ''}`} data-id="element-6113" data-mp="7gtfu9w86dbb" />
          </li>)}
      </ul>

      <div className="mt-5 flex flex-wrap items-center gap-x-4 gap-y-3" data-id="element-6114" data-mp="3tp2sd5l1imjs">
        {allSoldOut ? <p className="text-[13px] text-clay" data-id="element-6115" data-mp="3orj2f8ezclc0">Dit protocol is tijdelijk uitverkocht.</p> : <button type="button" onClick={() => addRoutine(routine.id)} aria-label={`${routine.name} in winkelmand, ${euro(price)}`} className={`${btnPrice} sm:w-auto sm:min-w-[18rem]`} data-id="element-6116" data-mp="3kqhbrfz4phln">
            <span className={btnPriceLabel} data-id="element-6117" data-mp="30vfsmlv167sl">Protocol in de mand</span>
            <span className={btnPriceAmount} data-id="element-6118" data-mp="30v61guy91ulb">{euro(price)}</span>
          </button>}
        {treatment ? <Link to="/routines" className="inline-flex items-center gap-1 whitespace-nowrap text-[13px] text-muted transition-colors duration-150 ease-soft hover:text-ink" data-id="element-6119" data-mp="35s65l0bjgn9s">
            Alle protocollen
            <ArrowRightIcon className="h-3.5 w-3.5" strokeWidth={1.5} aria-hidden="true" data-id="element-6120" data-mp="3eonia7zjwt7n" />
          </Link> : <button type="button" onClick={openQuiz} aria-haspopup="dialog" className="text-[13px] text-muted underline-offset-4 transition-colors duration-150 ease-soft hover:text-ink hover:underline" data-id="element-6121" data-mp="2mvdb50qmxgdv">
            Niet zeker? Doe de huidtest
          </button>}
      </div>
    </section>;
}